import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  AddOrderItemModalRootScreenParamList,
  EditStockOrderRootScreenParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { SearchSelectProductScreen } from "../SearchSelectProductScreen";
import { SuggestType } from "@towersystems/roam-common/lib/generated-types";
import { useFullTextSearch } from "../../../../utilities/fulltext-search";
import { useSelectedProduct } from "../../../invoice-arrival/utils/selected-product/hooks";
import { FulltextProductSearchContext } from "../../../../utilities/fulltext-search/context";
import { SelectedProductContext } from "../../../invoice-arrival/utils/selected-product/context";
import { AddProductOrderItemRootScreen } from "../AddProductOrderItemRootScreen";
import { AddOrderItemScreenActionsContext } from "../AddOrEditOrderItemScreen/context";
import React from "react";
import { CreateProductRootScreen } from "../../../products/screens/CreateProductRootScreen";
import { ProductFormActionsContext } from "../../../products/components/ProductForm/context";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";
import ProductModel from "../../../../utilities/data/model/Product";
import { ProductsFilterValues } from "../../../products/types";
import { useListFilter } from "../../../../utilities/list-filter";
import { defaultProductFilterValues } from "../../../products/common";
import { ListFilterProvider } from "../../../../utilities/list-filter/use-list-filter-context";
import { ProductListFilterRootScreen } from "../../../products/screens/ProductListFilterRootScreen";

export type AddOrderItemModalRootScreenProps = StackScreenProps<
  EditStockOrderRootScreenParamList,
  "AddOrderItemModalRootScreen"
>;

export const AddOrderItemModalRootScreen = ({
  navigation,
}: AddOrderItemModalRootScreenProps) => {
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();
  const selectedProductContext = useSelectedProduct();
  const database = useDatabase();

  const fullTextSearch = useFullTextSearch({
    type: SuggestType.PRODUCT,
    responseType: "complete",
    activeOnly: true,
  });

  const Drawer =
    createStackHeaderNavigator<AddOrderItemModalRootScreenParamList>();

  const afterAfterAddProductItem = React.useCallback(async () => {
    navigation.pop();
  }, []);

  const filterContext = useListFilter<ProductsFilterValues>({
    defaultValues: defaultProductFilterValues,
  });

  return (
    <ListFilterProvider {...filterContext}>
      <AddOrderItemScreenActionsContext.Provider
        value={{
          afterSubmitSuccess: afterAfterAddProductItem,
        }}
      >
        <SelectedProductContext.Provider value={selectedProductContext}>
          <FulltextProductSearchContext.Provider value={fullTextSearch}>
            <ProductFormActionsContext.Provider
              value={{
                onAfterAddProduct: async (product) => {
                  try {
                    await fetchAndSyncEntity("products");
                    const newProduct = await database
                      .get<ProductModel>("products")
                      .find(product.id);
                    selectedProductContext.setProduct(newProduct);
                    navigation.navigate("AddOrderItemModalRootScreen", {
                      screen: "AddProductOrderItemRootScreen",
                      /* @ts-ignore */
                      productId: product.id,
                    });
                  } catch (err) {
                    console.log(err);
                  }
                },
              }}
            >
              <Drawer.Navigator
                screenOptions={{
                  animationEnabled: true,
                  cardStyleInterpolator:
                    CardStyleInterpolators.forHorizontalIOS,
                  headerLeft: () => <ModalCloseButton type="Close" />,
                }}
              >
                <Drawer.Group>
                  <Drawer.Screen
                    name="SearchSelectProductScreen"
                    component={SearchSelectProductScreen}
                  />
                </Drawer.Group>
                <Drawer.Group
                  screenOptions={{
                    headerShown: false,
                  }}
                >
                  <Drawer.Screen
                    name="AddProductOrderItemRootScreen"
                    component={AddProductOrderItemRootScreen}
                  />
                  <Drawer.Screen
                    name="CreateProductRootScreen"
                    component={CreateProductRootScreen}
                  />
                </Drawer.Group>
                <Drawer.Group
                  screenOptions={{
                    headerShown: false,
                    presentation: "modal",
                  }}
                >
                  <Drawer.Screen
                    name="ProductListFilterRootScreen"
                    component={ProductListFilterRootScreen}
                  />
                </Drawer.Group>
              </Drawer.Navigator>
            </ProductFormActionsContext.Provider>
          </FulltextProductSearchContext.Provider>
        </SelectedProductContext.Provider>
      </AddOrderItemScreenActionsContext.Provider>
    </ListFilterProvider>
  );
};
